import { FC ,memo} from "react";
import { NotTreatedData } from "src/pages/actionDashboard/types";
import NoDataFound from "src/components/noDataFoundComponent";
import CopayBucketTableRow from "./copayBucketTableRow";

type Props = {
  data: NotTreatedData[];
  refreshListing: () => void;
};

const CopayBucketTableBody: FC<Props> = ({ data, refreshListing }) => (
  
  <tbody>
    {data && data.length > 0 ?
      data.map((row, idx) => (
        <CopayBucketTableRow
          row={row}
          refreshListing={refreshListing}
        />
      )):<NoDataFound/>
      }
  </tbody>
);

export default memo(CopayBucketTableBody);
